<template>
    <div :class="['new-client-v3 !ppv2-h-fit', v3 ? 'ppv2-flex-1 ppv2-flex' : '']">
        <button
            v-if="!inline"
            type="button"
            :class="[v3 ? 'v3-client-toggle-btn poppinsMedium ppv2-w-full' : 'v-btn bg-transparent Clientp']"
            @click="openModal()"
        >
            Nouveau
        </button>

        <!-- Modal Mode -->
        <CustomDialog
            v-if="!inline"
            v-model="showModal"
            :defaultTitle="'Coordonnées de votre client'"
            width="800px"
            height="70vh"
        >
            <template #content>
                <div class="form-content ppv2-p-4">
                    <v-progress-linear
                        v-show="loadingAddClient > 0"
                        indeterminate
                        color="#7D2DBD"
                        class="ppv2-mb-4"
                    ></v-progress-linear>
                    <v-alert class="ppv2-mb-6" color="#E74C3C" v-if="errors?.length > 0" type="error" outlined>
                        <li v-for="(error, key) in errors" :key="key" class="poppinsRegular">
                            {{ error }}
                        </li>
                    </v-alert>

                    <div class="ppv2-flex ppv2-flex-col" :style="{ gap: normalizeSize(16, true) }">
                        <!-- Individual/Professional Toggle -->
                        <div class="ppv2-w-full md:ppv2-w-1/2">
                            <SegmentedControl
                                v-model="customer_type"
                                :options="[
                                    { label: 'Client Particulier', value: 0 },
                                    { label: 'Client professionnel', value: 1 },
                                ]"
                                label="Type de client"
                            />
                        </div>

                        <!-- Main Form Fields -->
                        <div class="ppv2-grid ppv2-grid-cols-1 md:ppv2-grid-cols-2 ppv2-gap-x-4 ppv2-gap-y-3">
                            <div class="ppv2-col-span-1 md:ppv2-col-span-2">
                                <BaseSelect
                                    :label="$t('customerInfo.form.civility.label')"
                                    v-model="gender"
                                    :options="genderOptions"
                                    :placeholder="$t('customerInfo.form.civility.label')"
                                    :customLabelStyle="`font-size: ${normalizeSize(14, true)}`"
                                    customLabelClass="poppinsMedium ppv2-text-black"
                                    class-input-add="ppv2-min-h-[40px]"
                                    fixed-dropdown
                                />
                            </div>

                            <!-- Professional Fields -->
                            <template v-if="customer_type === 1">
                                <CustomInput
                                    :label="$t('form_customer_v2.main_information.company_name.label')"
                                    :placeholder="$t('form_customer_v2.main_information.company_name.placeholder')"
                                    v-model="social_reason"
                                    type="text"
                                    customLabelClass="poppinsMedium ppv2-text-black"
                                    :customSizeLabel="14"
                                    class-input-add="ppv2-min-h-[40px]"
                                />
                                <CustomInput
                                    :label="$t('form_customer_v2.main_information.siret.label')"
                                    :placeholder="$t('form_customer_v2.main_information.siret.placeholder')"
                                    v-model="siret"
                                    type="text"
                                    customLabelClass="poppinsMedium ppv2-text-black"
                                    :customSizeLabel="14"
                                    class-input-add="ppv2-min-h-[40px]"
                                />
                                <CustomInput
                                    :label="$t('form_customer_v2.main_information.function.label')"
                                    v-model="fonction"
                                    type="text"
                                    customLabelClass="poppinsMedium ppv2-text-black"
                                    :customSizeLabel="14"
                                    class-input-add="ppv2-min-h-[40px]"
                                />
                                <CustomInput
                                    label="TVA"
                                    v-model="tva"
                                    type="text"
                                    customLabelClass="poppinsMedium ppv2-text-black"
                                    :customSizeLabel="14"
                                    class-input-add="ppv2-min-h-[40px]"
                                />
                            </template>

                            <CustomInput
                                :label="$t('form_customer_v2.main_information.first_name.label')"
                                v-model="first_name"
                                type="text"
                                :required="true"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />
                            <CustomInput
                                :label="$t('form_customer_v2.main_information.last_name.label')"
                                v-model="last_name"
                                type="text"
                                :required="true"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />
                            <CustomInput
                                :label="$t('form_customer_v2.main_information.email.label')"
                                v-model="email"
                                type="email"
                                :required="true"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />
                            <CustomInput
                                :label="$t('form_customer_v2.main_information.phone.label')"
                                v-model="phone"
                                type="tel"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />

                            <BaseDateInput
                                :label="$t('form_customer_v2.main_information.date_of_birth.label')"
                                v-model="birthday"
                                :placeholder="$t('form_customer_v2.main_information.date_of_birth.placeholder')"
                                :customSizeLabel="14"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                input-class="!ppv2-min-h-[40px]"
                            />
                            <BaseSelect
                                label="Groupe Client"
                                v-model="customer_group"
                                :options="groupOptions"
                                placeholder="Sélectionner un groupe"
                                :customLabelStyle="`font-size: ${normalizeSize(14, true)}`"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                class-input-add="ppv2-min-h-[40px]"
                                fixed-dropdown
                            />
                            <BaseSelect
                                label="Source d'acquisition"
                                v-model="origin"
                                :options="originOptions"
                                placeholder="Sélectionner une source"
                                :customLabelStyle="`font-size: ${normalizeSize(14, true)}`"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                class-input-add="ppv2-min-h-[40px]"
                                fixed-dropdown
                            />
                            <CustomInput
                                label="Pays"
                                v-model="country"
                                type="text"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />
                            <CustomInput
                                label="Ville"
                                v-model="city"
                                type="text"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />
                            <CustomInput
                                label="Adresse"
                                v-model="street"
                                type="text"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />
                            <CustomInput
                                label="Code postal"
                                v-model="postal_code"
                                type="text"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />
                        </div>
                    </div>
                </div>
            </template>
            <template #actions>
                <BaseButton
                    variant="primary"
                    :disabled="!email || !first_name || !last_name || !email.includes('@')"
                    @click="addClient"
                    :loading="loadingAddClient > 0"
                    customClass="ppv2-px-8"
                >
                    Ajouter
                </BaseButton>
            </template>
        </CustomDialog>

        <!-- Inline Mode -->
        <div v-else-if="inline" class="ppv2-w-full ppv2-relative">
            <div
                class="ppv2-rounded-[12px] ppv2-shadow-none ppv2-border ppv2-border-black ppv2-border-opacity-10 ppv2-flex ppv2-flex-col"
            >
                <div class="form-content ppv2-p-4 ppv2-pb-20">
                    <v-progress-linear
                        v-show="loadingAddClient > 0"
                        indeterminate
                        color="#7D2DBD"
                        class="ppv2-mb-4"
                    ></v-progress-linear>
                    <v-alert class="ppv2-mb-6" color="#E74C3C" v-if="errors?.length > 0" type="error" outlined>
                        <li v-for="(error, key) in errors" :key="key" class="poppinsRegular">
                            {{ error }}
                        </li>
                    </v-alert>

                    <div class="ppv2-flex ppv2-flex-col" :style="{ gap: normalizeSize(16, true) }">
                        <!-- Individual/Professional Toggle -->
                        <div class="ppv2-w-full md:ppv2-w-1/2">
                            <SegmentedControl
                                v-model="customer_type"
                                :options="[
                                    { label: 'Client Particulier', value: 0 },
                                    { label: 'Client professionnel', value: 1 },
                                ]"
                                label="Type de client"
                            />
                        </div>

                        <!-- Main Form Fields -->
                        <div class="ppv2-grid ppv2-grid-cols-1 md:ppv2-grid-cols-2 ppv2-gap-x-4 ppv2-gap-y-3">
                            <div class="ppv2-col-span-1 md:ppv2-col-span-2">
                                <BaseSelect
                                    :label="$t('customerInfo.form.civility.label')"
                                    v-model="gender"
                                    :options="genderOptions"
                                    :placeholder="$t('customerInfo.form.civility.label')"
                                    :customLabelStyle="`font-size: ${normalizeSize(14, true)}`"
                                    customLabelClass="poppinsMedium ppv2-text-black"
                                    class-input-add="ppv2-min-h-[40px]"
                                    fixed-dropdown
                                />
                            </div>

                            <!-- Professional Fields -->
                            <template v-if="customer_type === 1">
                                <CustomInput
                                    :label="$t('form_customer_v2.main_information.company_name.label')"
                                    :placeholder="$t('form_customer_v2.main_information.company_name.placeholder')"
                                    v-model="social_reason"
                                    type="text"
                                    customLabelClass="poppinsMedium ppv2-text-black"
                                    :customSizeLabel="14"
                                    class-input-add="ppv2-min-h-[40px]"
                                />
                                <CustomInput
                                    :label="$t('form_customer_v2.main_information.siret.label')"
                                    :placeholder="$t('form_customer_v2.main_information.siret.placeholder')"
                                    v-model="siret"
                                    type="text"
                                    customLabelClass="poppinsMedium ppv2-text-black"
                                    :customSizeLabel="14"
                                    class-input-add="ppv2-min-h-[40px]"
                                />
                                <CustomInput
                                    :label="$t('form_customer_v2.main_information.function.label')"
                                    v-model="fonction"
                                    type="text"
                                    customLabelClass="poppinsMedium ppv2-text-black"
                                    :customSizeLabel="14"
                                    class-input-add="ppv2-min-h-[40px]"
                                />
                                <CustomInput
                                    label="TVA"
                                    v-model="tva"
                                    type="text"
                                    customLabelClass="poppinsMedium ppv2-text-black"
                                    :customSizeLabel="14"
                                    class-input-add="ppv2-min-h-[40px]"
                                />
                            </template>

                            <CustomInput
                                :label="$t('form_customer_v2.main_information.first_name.label')"
                                v-model="first_name"
                                type="text"
                                :required="true"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />
                            <CustomInput
                                :label="$t('form_customer_v2.main_information.last_name.label')"
                                v-model="last_name"
                                type="text"
                                :required="true"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />
                            <CustomInput
                                :label="$t('form_customer_v2.main_information.email.label')"
                                v-model="email"
                                type="email"
                                :required="true"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />
                            <CustomInput
                                :label="$t('form_customer_v2.main_information.phone.label')"
                                v-model="phone"
                                type="tel"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />

                            <BaseDateInput
                                :label="$t('form_customer_v2.main_information.date_of_birth.label')"
                                v-model="birthday"
                                :placeholder="$t('form_customer_v2.main_information.date_of_birth.placeholder')"
                                :customSizeLabel="14"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                input-class="!ppv2-min-h-[40px]"
                            />
                            <BaseSelect
                                label="Groupe Client"
                                v-model="customer_group"
                                :options="groupOptions"
                                placeholder="Sélectionner un groupe"
                                :customLabelStyle="`font-size: ${normalizeSize(14, true)}`"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                class-input-add="ppv2-min-h-[40px]"
                                fixed-dropdown
                            />
                            <BaseSelect
                                label="Source d'acquisition"
                                v-model="origin"
                                :options="originOptions"
                                placeholder="Sélectionner une source"
                                :customLabelStyle="`font-size: ${normalizeSize(14, true)}`"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                class-input-add="ppv2-min-h-[40px]"
                                fixed-dropdown
                            />
                            <CustomInput
                                label="Pays"
                                v-model="country"
                                type="text"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />
                            <CustomInput
                                label="Ville"
                                v-model="city"
                                type="text"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />
                            <CustomInput
                                label="Adresse"
                                v-model="street"
                                type="text"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />
                            <CustomInput
                                label="Code postal"
                                v-model="postal_code"
                                type="text"
                                customLabelClass="poppinsMedium ppv2-text-black"
                                :customSizeLabel="14"
                                class-input-add="ppv2-min-h-[40px]"
                            />
                        </div>
                    </div>
                </div>
                <!-- Sticky Footer -->
                <div
                    class="ppv2-sticky ppv2-bottom-0 ppv2-w-full ppv2-flex ppv2-justify-center ppv2-pb-6 ppv2-pt-4 ppv2-backdrop-blur-sm ppv2-z-10 ppv2-rounded-b-[12px]"
                    style="border-top: 1px solid rgba(0, 0, 0, 0.05); bottom: -48px"
                >
                    <BaseButton
                        variant="primary"
                        :disabled="!email || !first_name || !last_name || !email.includes('@')"
                        @click="addClient"
                        :loading="loadingAddClient > 0"
                        customClass="ppv2-px-8"
                    >
                        Ajouter
                    </BaseButton>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ApiManager from '../../_core/ApiManager'
import CustomInput from '../../../Inputs/CustomInput.vue'
import BaseButton from '../../../Shared/BaseButton.vue'
import BaseSelect from '../../../Shared/BaseSelect.vue'
import BaseDateInput from '../../../Shared/BaseDateInput.vue'
import CustomDialog from '../../../Shared/CustomDialog.vue'
import normalizeSize from '../../../../utils/normalizeSize'
import SegmentedControl from '../../../Shared/SegmentedControl.vue'

export default {
    components: {
        CustomInput,
        BaseButton,
        BaseSelect,
        BaseDateInput,
        CustomDialog,
        SegmentedControl,
    },
    props: {
        inline: {
            type: Boolean,
            default: false,
        },
        v3: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showModal: this.inline,
            errors: [],
            customer_groups: [],
            origins: [],
            gender: null,
            origin: null,
            // modal
            customer_type: 0,
            siret: null,
            fonction: null,
            tva: null,
            social_reason: null,
            first_name: null,
            customer_group: '',
            last_name: null,
            email: null,
            phone: null,
            loadingAddClient: 0,
            msgErrorAddClient: '',
            birthday: null,
            country: null,
            city: null,
            postal_code: null,
            street: null,
            genders: ['Homme', 'Femme', 'Autre'],
        }
    },
    computed: {
        genderOptions() {
            return this.genders.map((g) => ({ label: g, value: g }))
        },
        groupOptions() {
            return this.customer_groups.map((g) => ({ label: g.name, value: g.id }))
        },
        originOptions() {
            return this.origins.map((o) => ({ label: o.name, value: o.id }))
        },
    },
    methods: {
        normalizeSize,
        async addClient() {
            this.loadingAddClient += 1
            // TODO: add this.birthday later when back is done
            this.errors = []
            ApiManager.createClient(
                this.first_name,
                this.last_name,
                this.gender,
                this.email,
                this.phone,
                this.customer_type,
                this.siret,
                this.tva,
                this.social_reason,
                this.fonction,
                this.customer_group,
                this.origin,
                this.birthday,
                this.country,
                this.city,
                this.street,
                this.postal_code
            )
                .then((res) => {
                    if (isNaN(res)) {
                        this.msgErrorAddClient = 'Une erreur est survenue'
                        var keys = Object.keys(res.errors)
                        keys.forEach((key) => {
                            this.errors.push(res.errors[key][0])
                        })
                    } else {
                        const client = {
                            id: res,
                            email: this.email,
                            first_name: this.first_name,
                            last_name: this.last_name,
                        }
                        this.$emit('add-client', client)
                        this.first_name = null
                        this.last_name = null
                        this.email = null
                        this.gender = null
                        this.phone = null
                        this.customer_type = 0
                        this.siret = null
                        this.tva = null
                        this.social_reason = null
                        this.fonction = null
                        this.customer_group = null
                        this.origin = null
                        this.birthday = null
                        this.country = null
                        this.city = null
                        this.street = null
                        this.postal_code = null
                        this.showModal = false
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        //  this.msgErrorAddClient = error.response.data.errors.email[0]
                        var keys = Object.keys(error.response.data.errors)
                        keys.forEach((key) => {
                            // console.log(error.response.data.errors[key][0], key)
                            this.errors.push(error.response.data.errors[key][0])
                            //console.log('test ' + typeof test)
                        })
                        //  console.log(this.msgErrorAddClient)
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        console.log(error.request)
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('Error', error.message)
                    }
                    //  console.log(error.config)
                })
                .finally(() => {
                    this.loadingAddClient -= 1
                })
        },
        async getListGroup() {
            await ApiManager.getCustomerGroup().then((groups) => {
                this.customer_groups = groups
            })
        },
        async getListOrigin() {
            await ApiManager.getOrigin().then((origins) => {
                this.origins = origins
            })
        },
        openModal() {
            this.showModal = true
        },
        closeModal() {
            this.showModal = false
        },
        getMaxBirthday() {
            const date = new Date()
            date.setFullYear(date.getFullYear() - 18)
            return date.toISOString().split('T')[0]
        },
    },
    mounted() {
        this.getListGroup()
        this.getListOrigin()
        this.birthday = this.getMaxBirthday()
    },
}
</script>
<style scoped lang="scss">
.new-client-v3 {
    width: 100%;
}

.card-cord-clt {
    background-color: #fff !important;
}
</style>
